<template>
  <div id="MainInputBox">
    <!--  -->
    <!--  -->
    <input
      v-if="type == 'datetime-local'"
      ref="input"
      :name="name"
      :type="type"
      :value="value"
      :readonly="readonly"
      @input="$emit('input', $event.target.value)"
      @click="$refs.input.showPicker()"
      :placeholder="placeholder"
    />
    <input
      v-else
      :name="name"
      :type="type"
      :value="value"
      :readonly="readonly"
      @input="$emit('input', $event.target.value)"
      :placeholder="placeholder"
    />
    <p v-show="showErrorMessage" class="error_message">{{ errorMessage }}</p>
  </div>
</template>

<script>
export default {
  name: "InputBox",
  props: {
    name: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    value: {
      required: true,
    },
    errorMessage: {
      type: String,
      default: "",
    },
    showErrorMessage: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
